import Axios from 'axios';
import env from '../env';
import { isRetryableError, delay, getMaxRetryCount } from 'retryHelper';

const publicHttpClient = Axios.create({
  baseURL: `${env.SERVER_ENDPOINT}/api/`,
});

publicHttpClient.interceptors.request.use(
  async function (config) {
    if (config.method !== 'OPTIONS') {
      config.headers.Authorization = `ApiKey ${env.API_KEY}`;
    }

    return config;
  },
  function (error) {
    return Promise.reject(error);
  },
);

publicHttpClient.interceptors.response.use(null, async (error) => {
  const { config } = error;

  if (isRetryableError(error) && config) {
    config.__retryCount = config.__retryCount || 0;

    if (config.__retryCount < getMaxRetryCount(config)) {
      config.__retryCount += 1;

      await delay(config.__retryCount);

      return publicHttpClient(config);
    }
  }

  return Promise.reject(error);
});

export default publicHttpClient;
